import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      d: "M20.05.75H3.95c-1.8 0-3.2 1.4-3.2 3.2v16.1c0 1.8 1.4 3.2 3.2 3.2h16.1c1.8 0 3.2-1.4 3.2-3.2V3.95c0-1.7-1.4-3.2-3.2-3.2"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      d: "M16.55 14.25c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2-2.2-1-2.2-2.2v-9c0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2-1 2.2-2.2 2.2h-9c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2 2.2 1 2.2 2.2v9c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2z"
    }, null, -1)
  ]));
}
const computerKeyboardCommandCmdControlCtrl = { render };
export {
  computerKeyboardCommandCmdControlCtrl as default,
  render
};
//# sourceMappingURL=computer-keyboard-command-cmd-control-ctrl.svg.js.map
